import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { HttpStatusCode } from "axios";

export const resendVerificationCode = createAsyncThunk(
  "aviationForm/resendVerificationCode",
  async ({ id }, { rejectWithValue }) => {
    const baseUrl =
      process.env.REACT_APP_USE_LOCAL_API_URL === "true"
        ? process.env.REACT_APP_LOCAL_API_URL
        : process.env.REACT_APP_EXTERNAL_API_URL;

    try {
      const endpoint = `/private_aviation/forms/${id}/send_email_confirmation`;

      const { status } = await axios.patch(`${baseUrl}${endpoint}`, null, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      // Accept 200 OK or 204 No-Content
      if (status !== HttpStatusCode.Ok && status !== HttpStatusCode.NoContent) {
        throw new Error(`Unexpected status: ${status}`);
      }

      return { id };
    } catch (err) {
      return rejectWithValue(err?.message || "Unable to resend code");
    }
  }
);
